module.exports = __webpack_public_path__ + "img/141.2.eefeeadf.png";